import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import { notificationsApi } from './notifications.api';
import type { NotificationsListParams } from '../types';

export const notificationKeys = {
  all: ['notifications'] as const,
  lists: () => [...notificationKeys.all, 'list'] as const,
  list: (filters: NotificationsListParams) =>
    [...notificationKeys.lists(), filters] as const,
  unreadCount: () => [...notificationKeys.all, 'unread-count'] as const
};

export const notificationQueries = {
  list: (filters: Omit<NotificationsListParams, 'page'> = {}) =>
    infiniteQueryOptions({
      queryKey: notificationKeys.list(filters),
      queryFn: ({ pageParam }) =>
        notificationsApi.getAll({ ...filters, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: (lastPage) =>
        lastPage.pagination?.hasNext ? lastPage.pagination.page + 1 : undefined
    }),

  unreadCountPolling: (options?: { pollingEnabled?: boolean }) =>
    queryOptions({
      queryKey: notificationKeys.unreadCount(),
      queryFn: () => notificationsApi.getUnreadCount(),
      enabled: options?.pollingEnabled ?? true,
      refetchInterval: options?.pollingEnabled ? 30_000 : false
    })
};
